import { render, staticRenderFns } from "./InstrumentDetail.vue?vue&type=template&id=b4c93f74"
import script from "./InstrumentDetail.vue?vue&type=script&lang=js"
export * from "./InstrumentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports